/**
 * Gender categories matching standard booking record categories
 * Standard categories used in California sheriff booking records
 */
export const GENDERS = ['Male', 'Female', 'Nonbinary'];
